import { createSlice } from "@reduxjs/toolkit";
import { isUndefined } from "lodash";
import { DisplayAs } from "../../components/ux/ins-date-pickers/types";
const initialState = {
    displayAs: DisplayAs.Quarter,
    opened: false
};
const slice = createSlice({
    initialState,
    name: "datepickerReducers",
    reducers: {
        resetYearMonthAndQuarter: (state) => {
            delete state.year;
            delete state.quarter;
            delete state.month;
        },
        setDisplayAs: (state, action) => {
            if (!isUndefined(action.payload)) {
                state.displayAs = action.payload;
            }
        },
        setMonth: (state, action) => {
            if (!isUndefined(action.payload)) {
                state.month = action.payload;
            }
        },
        setQuarter: (state, action) => {
            if (!isUndefined(action.payload)) {
                state.quarter = action.payload;
            }
        },
        setSelectedTabUid: (state, action) => {
            if (!isUndefined(action.payload)) {
                state.selectedTabUid = action.payload;
            }
        },
        setYear: (state, action) => {
            if (!isUndefined(action.payload)) {
                state.year = action.payload;
            }
        }
    }
});
export const datepickerReducers = slice.reducer;
export const { setMonth, setYear, setQuarter, resetYearMonthAndQuarter, setSelectedTabUid, setDisplayAs } = slice.actions;
